// Which status tab a list opens on (finance-real, the user 2026-10-23: a default tab landed on an empty list while items
// waited under another). With no `show=` in the URL, a status-tabbed list (Jobs, Quotes and Invoices, on /finance and the
// client page) opens on its default while that tab has rows, else on the first tab in display order that has any, and on
// its default when every tab is empty or the counts are not in yet. Picking a tab always writes it to the URL, so a pick
// never resolves to another tab.
export function showTab<S extends string>(value: string | null, order: readonly S[], fallback: S, count: ((s: S) => number) | null): S {
  const named = order.find((s) => s === value);
  if (named) return named;
  if (!count || count(fallback) > 0) return fallback;
  return order.find((s) => count(s) > 0) ?? fallback;
}
